import React, { Component } from 'react';
import { Button } from 'antd';
import { Building2, Download, Plus } from 'lucide-react';
import Inherit from '../../core/inherit';
import ClientsController from './clients.controller';
import withNavigate from '../../core/withNavigate';
import { Layout, AnalyticsSkeleton, TableSkeleton, PageHeader } from '../common';
import { ClientTable, CreateClientDrawer, ClientAnalytics } from './elements';

class ShelfClients extends Inherit(ClientsController, Component) {
    state = {
        loading: true,
        clients: [],
        open: false,
        users: [],
        client: null,
        rows: [],
        disabled: false,
        analytics: {
            totalClients: 0,
            modernoClients: 0,
            tradicionalClients: 0,
            activeClients: 0,
            inactiveClients: 0,
            recentlyAdded: 0,
            recentlyUpdated: 0
        }
    };

    renderHeader(withActions) {
        return (
            <PageHeader
                icon={<Building2 />}
                title="Clientes"
                description="Gestiona los clientes y sus asignaciones"
                actions={
                    withActions && (
                        <>
                            <Button icon={<Download />} onClick={() => this.downloadClients()}>
                                Exportar
                            </Button>
                            {this.canCreateClients && (
                                <Button type="primary" icon={<Plus />} onClick={() => this.showDrawer()}>
                                    Crear Cliente
                                </Button>
                            )}
                        </>
                    )
                }
            />
        );
    }

    render() {
        const { contextHolder } = this.props;
        const { rows, clients, loading, open, users, client, analytics } = this.state;

        if (loading) {
            return (
                <Layout current="clients" user={this.user}>
                    {this.renderHeader(false)}
                    <AnalyticsSkeleton cards={4} />
                    <TableSkeleton rows={10} columns={6} />
                </Layout>
            );
        }

        return (
            <Layout current="clients" user={this.user}>
                {this.renderHeader(true)}

                <div className="animate-in">
                    <ClientAnalytics analytics={analytics} />
                    <ClientTable
                        setRows={this.setRows.bind(this)}
                        updateClientById={this.updateClientById.bind(this)}
                        rows={rows}
                        clients={clients}
                        loading={loading}
                        showDrawer={this.showDrawer.bind(this)}
                    />
                    <CreateClientDrawer
                        open={open}
                        users={users}
                        client={client}
                        contextHolder={contextHolder}
                        isEdit={client ? true : false}
                        setOpen={this.setOpen.bind(this)}
                        setClient={this.setClient.bind(this)}
                        createOrUpdateClient={this.createOrUpdateClient.bind(this)}
                    />
                </div>
            </Layout>
        );
    }
}

export default withNavigate(ShelfClients);
